import React, { useEffect } from "react";  // ← Ajouter useEffect
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { supabase } from './supabaseClient';  // ← Ajouter cet import
import HomePage from "./pages/HomePage";
import StudentLogin from "./pages/StudentLogin";
import ProfessorLogin from "./pages/ProfessorLogin";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Professeurs from "./pages/Professeurs";
import ProfesseurDetail from "./pages/ProfesseurDetail";
import Reservation from "./pages/Reservation";
import Planning from "./pages/Planning";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from './pages/ForgotPassword';
import ReviewCourse from './pages/ReviewCourse';
import MyReviews from './pages/MyReviews';
import Abonnement from './pages/Abonnement';
import AdminCandidatures from './pages/AdminCandidatures';
import CoursVideo from './pages/CoursVideo';
import AdminPayouts from './pages/AdminPayouts';
import ModernProfDashboard from './components/ModernProfDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminMessages from './pages/AdminMessages';
import AdminMonitoring from './pages/AdminMonitoring';
import AdminSessionQuality from './pages/AdminSessionQuality';
import Contact from './pages/Contact';
import CGU from './pages/CGU';
import MentionsLegales from './pages/MentionsLegales';
import Confidentialite from './pages/Confidentialite';
import Header from './components/Header';

function App() {
  // Écouter les changements d'authentification globalement
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      
      if (event === 'TOKEN_REFRESHED') {
      }
      
      if (event === 'SIGNED_OUT') {
        window.location.href = '/login';
      }
    });
 return () => subscription.unsubscribe();
  }, []);

  return (
    <Router>
     <Header />
      <div style={{ paddingTop: '60px' }}> 
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<StudentLogin />} />
        <Route path="/professor-login" element={<ProfessorLogin />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/prof-dashboard" element={<ModernProfDashboard />} />
        <Route path="/professeurs" element={<Professeurs />} />
        <Route path="/professeur/:id" element={<ProfesseurDetail />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/planning" element={<Planning />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/review/:coursId" element={<ReviewCourse />} />
        <Route path="/my-reviews" element={<MyReviews />} />
        <Route path="/abonnement" element={<Abonnement />} />
        <Route path="/admin/candidatures" element={<AdminCandidatures />} />
        <Route path="/cours/:channelName" element={<CoursVideo />} />
        <Route path="/admin/paiements" element={<AdminPayouts />} />
        <Route path="/prof-modern" element={<ModernProfDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/monitoring" element={<AdminMonitoring />} />
        <Route path="/admin/session-quality" element={<AdminSessionQuality />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/confidentialite" element={<Confidentialite />} /> 
        <Route path="/admin/messages" element={<AdminMessages />} />
      </Routes>
     </div>
    </Router>
  );
}

export default App;
